import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material"
import React, { useEffect, useReducer, useState } from "react"
import {
  getListExecutor,
  postPaymentCustom,
  resetAccountingFlag,
  resetExecutorFlag,
} from "store/actions"
import PropTypes from "prop-types"
import { LinearProgress } from "@mui/material"
import { connect } from "react-redux"
import { DataGrid, GridToolbar, faIR } from "@mui/x-data-grid"
import NumberFormat from "react-number-format"
import { setInvalidateEmpty } from "common/global"
import { PersianDatePicker } from "components/Common/PersianDatePicker"

const Payment = props => {
  const { lstExecutor, loading } = props
  const [errorMessage, setErrorMessage] = useState(null)

  const [inputValue, setInputValue] = useState("")
  const [valueExecutor, setValueExecutor] = useState()
  const [fishDate, setFishDate] = useState("")
  const [formInput, setFormInput] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      executorId: "",
      amount: null,
      fishNumber: "",
      btId: "",
      solarFishDate: "",
      des: "",
      transactionStatus: "0",
    }
  )

  const handleInput = evt => {
    const name = evt.target.name
    const newValue = evt.target.value
    setFormInput({ [name]: newValue })
  }

  const handleSubmitForm = async (event, values) => {
    event.preventDefault()
    if (window.confirm("درصورتی که اطمینان دارد دکمه ثبت را بزنید")) {
      console.log("formInput.transactionStatus",formInput.transactionStatus);
      let gasProjectToSave = {
        ...formInput,
        solarFishDate: fishDate.persian,
        transactionStatus: Number(formInput.transactionStatus),
        fishNumber:
          formInput.transactionStatus === "0" ? formInput.fishNumber : "1001",
        btId:
          formInput.transactionStatus === "0"
            ? formInput.btId
            : window.Date.now().toString(),
      }
      console.log('gasProjectToSave', gasProjectToSave);
       await saveToDatabase(gasProjectToSave)
    }
  }
  

  const saveToDatabase = async values => {
    const { onPostPaymentCustom } = props
    await onPostPaymentCustom(values)
  }

  useEffect(() => {
    props.onGetListExecutor()
  }, [])

  useEffect(() => {
    setTimeout(() => {
      setErrorMessage(null)
    }, 5000)
  }, [errorMessage])
  useEffect(() => {
    setTimeout(() => {
      setErrorMessage(null)
      props.onResetAccountingFlag()
      props.onResetExecutorFlag()
    }, 5000)
  }, [errorMessage, props.success, props.error])
  return (
    <>
      <Grid item xs={12}>
        {props.error ? <Alert severity="error">{props.error}</Alert> : null}
        {props.success ? (
          <Alert severity="success">{props.success}</Alert>
        ) : null}
      </Grid>
      <form onSubmit={handleSubmitForm}>
        <Box>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <FormControl>
                <FormLabel id="radio-transactionStatus-label">
                  نوع واریز یا برداشت از کیف پول مجری را انتخاب کنید
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="radio-transactionStatus-label"
                  name="transactionStatus"
                  value={formInput.transactionStatus}
                  onChange={handleInput}
                >
                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="واریز"
                  />
                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="برداشت"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <PersianDatePicker
                setPersianDate={setFishDate}
                label={"تاریخ فیش واریزی"}
              />
            </Grid>

            {/* executor */}
            <Grid item xs={6}>
              <Autocomplete
                value={valueExecutor}
                autoHighlight
                disablePortal
                size="small"
                fullWidth
                style={{ width: "100%" }}
                onChange={(e, value) =>
                  handleInput({
                    target: { name: "executorId", value: value?.id },
                  })
                }
                inputValue={inputValue}
                onInputChange={(event, newInputValue) => {
                  setInputValue(newInputValue)
                }}
                id="executorId"
                options={lstExecutor?.map(option => ({
                  id: option.id,
                  label:
                    option.fullName +
                    "/" +
                    option.naCode +
                    "/" +
                    option.cellPhone,
                }))}
                sx={{ width: 500 }}
                renderInput={params => (
                  <TextField {...params} label="انتخاب مجری" required />
                )}
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    {option.label}
                  </Box>
                )}
              />
            </Grid>
            <Divider
              sx={{ mt: 3, pt: 1 }}
              style={{ width: "100%" }}
              variant="middle"
            />
            {/* amount */}
            <Grid item xs={4}>
              <NumberFormat
                className="MuiOutlinedInput-input MuiInputBase-input MuiInputBase-inputSizeSmall"
                value={formInput.amount}
                name="amount"
                margin="dense"
                onValueChange={value =>
                  handleInput({
                    target: { name: "amount", value: value.floatValue },
                  })
                }
                fullWidth
                size="small"
                label="مبلغ فیش"
                thousandSeparator={true}
                customInput={TextField}
                prefix={" ریال "}
              />
            </Grid>
            {/* fishNumber */}
            <Grid item xs={4}>
              {+formInput.transactionStatus === 0 ? (
                <TextField
                  required
                  fullWidth
                  margin="dense"
                  value={formInput.fishNumber}
                  name="fishNumber"
                  label="شماره فیش"
                  type="text"
                  size="small"
                  onChange={handleInput}
                  inputProps={{
                    style: { textAlign: "center" },
                  }}
                  onInvalid={setInvalidateEmpty}
                  onInput={setInvalidateEmpty}
                />
              ) : (
                ""
              )}
            </Grid>

            <Grid item xs={4}>
              {+formInput.transactionStatus === 0 ? (
                <TextField
                  required
                  fullWidth
                  margin="dense"
                  value={formInput.btId}
                  name="btId"
                  label="شماره پیگیری فیش"
                  type="text"
                  size="small"
                  onChange={handleInput}
                  inputProps={{
                    style: { textAlign: "center" },
                  }}
                  onInvalid={setInvalidateEmpty}
                  onInput={setInvalidateEmpty}
                />
              ) : (
                ""
              )}
            </Grid>
            <Divider
              sx={{ mt: 3, pt: 1 }}
              style={{ width: "100%" }}
              variant="middle"
            />
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                margin="dense"
                multiline={true}
                rows={4}
                value={formInput.des}
                name="des"
                label="توضیحات"
                type="text"
                size="small"
                onChange={handleInput}
                inputProps={{
                  style: { textAlign: "center" },
                }}
                onInvalid={setInvalidateEmpty}
                onInput={setInvalidateEmpty}
              />
            </Grid>

            <Grid item xs={12}>
              <Button disabled={loading} variant="contained" type="submit">
                ذخیره
              </Button>
            </Grid>
          </Grid>
        </Box>
      </form>
    </>
  )
}

Payment.propTypes = {
  lstExecutor: PropTypes.any,
  error: PropTypes.any,
  success: PropTypes.any,
  loading: PropTypes.any,
  onPostPaymentCustom: PropTypes.func,
  onResetAccountingFlag: PropTypes.func,
  onResetExecutorFlag: PropTypes.func,
}

const mapStateToProps = ({ Executors, Accounting }) => ({
  lstExecutor: Executors.lstExecutor,
  error: Executors.error || Accounting.error,
  success: Executors.success || Accounting.success,
  loading: Executors.loading || Accounting.loading,
})

const mapDispatchToProps = dispatch => ({
  onGetListExecutor: () => dispatch(getListExecutor()),
  onPostPaymentCustom: events => dispatch(postPaymentCustom(events)),
  onResetAccountingFlag: () => dispatch(resetAccountingFlag()),
  onResetExecutorFlag: () => dispatch(resetExecutorFlag()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Payment)
